import React from 'react'
import './footer.css'
import {FaFacebookSquare, FaInstagram, FaTwitter} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#home" className='footer__logo'>Juan</a>

      <ul className='permalinks'>
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
{/*         <li><a href="#testimonials">Testimonials</a></li>
 */}        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
       <a href="https://www.facebook.com/profile.php?id=100089689757841" target='blank' rel="noreferrer"><FaFacebookSquare /></a>
       <a href="https://www.instagram.com/juancarbajalfullstack/" target='blank' rel="noreferrer"><FaInstagram/></a>
       <a href="https://twitter.com/JuanC_FullStack" target='blank' rel="noreferrer"><FaTwitter/></a>

      </div>

      <div className='footer__copyright'>
        <small>&copy; JUAN's PORTFOLIO. All rights reserved.</small>
      </div>
    </footer>
    )
}

export default Footer